import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.jsx';
import './styles.css';

ReactDOM.render(<App />, document.getElementById('root'));
